/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import ChannelFacebookMessengerLoginButton from './ChannelFacebookMessengerLoginButton';
import { BotsCreators } from '../../../../../store/actions/bots';
import { setAuthState } from '../../../../../store/actions/facebook-messenger';
import { FACEBOOK_AUTH_RESET } from './facebook-api';
import { ChannelId } from '../../../../../util/channels';

/**
 * Component for showing the user, information about the facebook messenger channel if is config
 *
 * @param {object} props
 * @returns
 */
const ChannelFacebookMessengerInfo = (props) => {
  const { facebookAuth, channelData } = props;
  const { picture, name } =
    facebookAuth.accessToken !== '' ? facebookAuth : channelData.facebookUser;
  const { height, width, url } = picture.data;
  const imgStyle = { height, width, borderRadius: 50 };

  /**
   * Called when user click on label for removing his user from boteria
   */
  const onClickRemoveFacebookUser = () => {
    const { bot, setAuthState, updateBotRequest } = props;
    const { _id: botId, channels } = bot;
    const updatedBot = {
      channels: channels.filter(
        ({ channelId }) => channelId !== ChannelId.FacebookMessenger
      ),
    };

    setAuthState(FACEBOOK_AUTH_RESET);
    updateBotRequest(botId, updatedBot);
  };

  /**
   * Render custom button for continue as a last facebook user logged in
   * @param {object} renderProps props that came from Facebook Login Button Component
   */
  const renderChangeFacebookUserButton = (renderProps) => {
    if (facebookAuth.accessToken !== '') {
      return (
        <Fragment>
          <a onClick={renderProps.onClick} style={{ cursor: 'pointer' }}>
            (alterar)
          </a>
          <a
            className="remove-user"
            onClick={onClickRemoveFacebookUser}
            style={{ cursor: 'pointer' }}
          >
            remover usuário
          </a>
        </Fragment>
      );
    }
    return false;
  };

  return (
    <div className="container-user-info">
      <img src={url} style={imgStyle} alt="avatar" />
      <div className="container-user-info-text">
        <p className="user-info-logged-as">Logado como</p>
        <p className="user-info-name">
          {`${name} `}
          <ChannelFacebookMessengerLoginButton
            customButton={renderChangeFacebookUserButton}
          />
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
    facebookAuth: state.facebookMessenger.facebookAuth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...BotsCreators, setAuthState }, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessengerInfo))
);
